<!-- <a matTooltip="{{this.translate.data['TOOLTIPREMOVEUSERTENANCY'] | translate}}" (click)="deleteTenant()">
    <mat-icon aria-hidden="false" aria-label="icon">{{icon_delete}}</mat-icon>
</a> -->
<a>
    <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 4px;" matTooltip="{{this.translate.data['TOOLTIPREMOVEUSERTENANCY'] | translate}}" (click)="deleteTenant()">Entfernen</button>
</a>

